import React from "react";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS } from "chart.js/auto";
import { dropdownStyles } from "../../buy/buy";
import ReactSelect from "react-select";
import Client from "../../../utils/client";
import { useState } from "react";

function BarChart({ prices, product }) {
  var data = {
    labels: product?.map((e) => e.market),
    datasets: [
      {
        label: `متوسط سعر ${product?.[0].product}`,
        data: product?.map((e) => e.price),
        backgroundColor: [
          "rgba(255, 99, 132, 0.2)",
          "rgba(54, 162, 235, 0.2)",
          "rgba(255, 206, 86, 0.2)",
          "rgba(75, 192, 192, 0.2)",
          "rgba(153, 102, 255, 0.2)",
          "rgba(255, 159, 64, 0.2)",
        ],
        borderColor: [
          "rgba(255, 99, 132, 1)",
          "rgba(54, 162, 235, 1)",
          "rgba(255, 206, 86, 1)",
          "rgba(75, 192, 192, 1)",
          "rgba(153, 102, 255, 1)",
          "rgba(255, 159, 64, 1)",
        ],
        borderWidth: 1,
      },
    ],
  };
  var options = {
    maintainAspectRatio: false,
    scales: {},
    legend: {
      labels: {
        fontSize: 25,
      },
    },
  };
  return (
    <div className="lg:w-[30rem] h-[20rem] ">
      {product && <Bar data={data} options={options} />}
    </div>
  );
}

export default BarChart;
